export default __webpack_public_path__ + "static/media/YOOZ-SCAN2PAY-BANNER.606f3691.png";